<template>
    <OutlineButton
        v-if="blok"
        :url="resolveLink(blok.url)"
        :title="blok.title"
        :size="size"
        :icon="icon"
        :icon-position="iconPosition"
        :bg="bg"
        :class="$attrs.class"
    ></OutlineButton>
</template>

<script lang="ts" setup>
import type { TertiaryButtonStoryblok } from '~/app/types/storyblok-types';
import { resolveLink } from '../../utils/resolveLink';
import OutlineButton from '../ui/OutlineButton.vue';

defineProps({
    blok: {
        type: Object as () => TertiaryButtonStoryblok,
        required: true,
    },
    size: {
        type: String as () => 'small' | 'medium',
        default: 'medium',
    },
    icon: {
        type: Boolean,
        default: false,
    },
    iconPosition: {
        type: String as () => 'left' | 'right',
        default: 'right',
    },
    bg: {
        type: String as () => 'light' | 'dark',
        default: 'light',
    },
});
</script>
